import {
  CLOUD_PROVIDER_ID_BY_NAME,
  prepareInstanceInitData,
  insertIf,
} from '@siren-frontend/shared';
import useSWR from 'swr';

import PricingCalculator from './PricingCalculator';

const AWS_PRICING_REGION = 1;
const GCP_PRICING_REGION = 30;

const apiUrl = process.env.calculatorApiUrl;

const AWS_INSTANCES_URL = `${apiUrl}/deployment/cloud-provider/${CLOUD_PROVIDER_ID_BY_NAME.AWS}/region/${AWS_PRICING_REGION}`;
const GCP_INSTANCES_URL = `${apiUrl}/deployment/cloud-provider/${CLOUD_PROVIDER_ID_BY_NAME.GCP}/region/${GCP_PRICING_REGION}`;

const fetcher = url => fetch(url).then(res => res.json());

function CalculatorDataProvider() {
  const awsInstancesResponse = useSWR(AWS_INSTANCES_URL, fetcher);
  const gcpInstancesResponse = useSWR(GCP_INSTANCES_URL, fetcher);

  const isLoading =
    (!awsInstancesResponse?.data && !awsInstancesResponse?.error) ||
    (!gcpInstancesResponse?.data && !gcpInstancesResponse?.error);

  const error = awsInstancesResponse?.error || gcpInstancesResponse?.error;

  let instances = [];
  if (!isLoading && !error) {
    instances = [
      ...insertIf(awsInstancesResponse?.data?.data?.instances),
      ...insertIf(gcpInstancesResponse?.data?.data?.instances),
    ].flat();
  }

  return (
    <PricingCalculator
      instances={prepareInstanceInitData(instances)}
      isLoading={isLoading}
      error={error}
    />
  );
}

export default CalculatorDataProvider;
